import { filter, map, mergeMap, Subscription } from 'rxjs';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LoaderService } from './service/loader.service';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { modalMdOptions } from './core/constants';
import { SupportUserInfoModalComponent } from './core/components/support-user-info-modal/support-user-info-modal.component';
import { USER_AUTHENTICATION_SERVICE, UserAuthInterface } from './core/services';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css'],
	standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

	private readonly PROJECT_NAME = 'KISNA-POS';
	private modalNavSub?: Subscription;
	isLoggedIn = false;
	//#region Constructor

	constructor(
		public _loaderService: LoaderService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private titleService: Title,
		@Inject(NgbModal) private _ngbModalService: NgbModal,
		@Inject(USER_AUTHENTICATION_SERVICE) private _userAuthInterface: UserAuthInterface
	) { }

	//#endregion

	//#region Methods
	ngOnInit() {
		window.addEventListener('error', (e: any) => {
			if (e.message && e.message.includes('ChunkLoadError')) {
				location.reload();
			}
		});

		this._loaderService.setDefaultIndicatorSourceUrl();

		this.modalNavSub = this.router.events
			.pipe(
				filter((e): e is NavigationStart =>
					e instanceof NavigationStart && e.navigationTrigger === 'popstate')
			)
			.subscribe(() => {
				if (this._ngbModalService.hasOpenModals()) {
					this._ngbModalService.dismissAll('navigation');
				}
			});

		this.router.events
			.pipe(
				filter(event => event instanceof NavigationEnd),
				map(() => {
					let route = this.activatedRoute;
					while (route.firstChild) {
						route = route.firstChild;
					}
					return route;
				}),
				mergeMap(route => route.data)
			)
			.subscribe(data => {
				const pageTitle = data['title'];
				const fullTitle = pageTitle ? `${this.PROJECT_NAME} | ${pageTitle}` : this.PROJECT_NAME;
				this.titleService.setTitle(fullTitle);

				this.updateLoginState();
			});
	}

	private updateLoginState(): void {
		const user = this._userAuthInterface.authenticatedUser;
		this.isLoggedIn = !!user && !this._userAuthInterface.isTokenExpired();
	}

	openUserDetailsModal(): void {
		let options = this._ngbModalService.open(SupportUserInfoModalComponent, modalMdOptions);
		options.result.then(
			(result) => {
				console.log('Modal closed with result:', result);
			},
			(reason) => {
				console.log('Modal dismissed with reason:', reason);
			}
		);
	}

	ngOnDestroy(): void {
		this.modalNavSub?.unsubscribe();
	}
}